import { isEmpty } from 'lodash';
import { getCartInfo } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';
import { BILLING_CYCLE, PlanModelInfo, planTypes } from '@/common/constants';
import { $config } from '@/global-install';

const UsersLimit = { max: 99, min: 1 };

const VisitorManagementPlanMap = {
  [BILLING_CYCLE.MONTHLY]: 'zm_visitor_management_monthly',
  [BILLING_CYCLE.ANNUAL]: 'zm_visitor_management_yearly',
};

export default (planMapJSON) => {
  // switch control
  if (!$config('enableVisitorMgtOnlineBuy') && !window.$context.is.edit) {
    return [];
  }
  const visitorManagement = planMapJSON.zvstmgt;
  if (isEmpty(visitorManagement)) {
    return [];
  }
  const result = [];
  Object.entries(VisitorManagementPlanMap).forEach(([billingCycle, planKey]) => {
    const planInfo = visitorManagement[planKey];
    if (!isEmpty(planInfo)) {
      const { plan_code, amount, category, parent_category } = planInfo;
      result.push({
        type: planTypes.VISITOR_MANAGEMENT,
        typeNameKey: 'billing.visitor_management.title',
        planNameKey: 'billing.visitor_management.title',
        standAlone: true,
        unit: planUnitMap.user,
        billing_cycle: billingCycle,
        cartInfo: getCartInfo(),
        dependBasePlanTypeList: [],
        supportCoupon: true,
        plan_code,
        amount,
        category,
        parent_category,
        ...UsersLimit,
        planModel: PlanModelInfo.license
      });
    }
  });
  return result;
};
